<template>
  <div class="VINSearch">
    <HeaderTop ref="shopcar"></HeaderTop>
    <HeaderSearch
      @getDataList="getDataList"
      :active="'VINSearch'"
      :flag="3"
    ></HeaderSearch>
    <Slider></Slider>
    <div style="width: 100%; height: 2px; background: #377cf1"></div>
    <div class="main">
      <div class="main-top">
        <span>VIN查询</span> &nbsp;<span>&gt;</span>&nbsp;<span>{{
          keyword
        }}</span>
      </div>
      <div class="main-car">
        <ul>
          <li>
            <p>车辆品牌</p>
            <p>{{ this.carResult.brand || '暂无' }}</p>
          </li>
          <li>
            <p>车系</p>
            <p>{{ this.carResult.series || '暂无' }}</p>
          </li>
          <li>
            <p>车型</p>
            <p>{{ this.carResult.model || '暂无' }}</p>
          </li>
          <li>
            <p>年款</p>
            <p>{{ this.carResult.model_year || '暂无' }}</p>
          </li>
          <li>
            <p>排量</p>
            <p>{{ this.carResult.cc || '暂无' }}</p>
          </li>
          <li>
            <p>变速箱</p>
            <p>{{ this.carResult.trans_code || '暂无' }}</p>
          </li>
          <li>
            <p>发动机</p>
            <p>{{ this.carResult.engine_no || '暂无' }}</p>
          </li>
        </ul>
      </div>
      <div class="main-search">
        <span class="w1">配件查询 </span>
        <Input
          v-model="searchData.keyword"
          placeholder="请输入配件名称/OE号"
          style="width: 421px"
        />
        <Button type="primary" @click="getDataList(2)">查询</Button>
      </div>
      <div class="main-resualt">
        <p class="main-p">查询结果</p>
        <div class="w12">
          <!-- 配件类型 -->
          <div class="navigation-grops">
            <p>配件类型</p>
            <ul>
              <li
                v-for="item in parTypeList"
                :key="item.id"
                :class="carchecked4 === item.id ? 'checked' : ''"
                @click="checked4(item)"
              >
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>
          <!-- 品牌 -->
          <div class="navigation-grops" id="wp">
            <p id="pp">品牌</p>
            <ul>
              <li
                v-for="item in brandList"
                :key="item.carBrandId"
                :class="carchecked5 === item.carBrandId ? 'checked' : ''"
                @click="checked5(item)"
              >
                <span>{{ item.carBrandName }}</span>
              </li>
            </ul>
          </div>
          <!-- 分组 -->
<!--          <div class="navigation-grops">-->
<!--            <p>分组</p>-->
<!--            <ul>-->
<!--              <li-->
<!--                v-for="item in groups"-->
<!--                :key="item.id"-->
<!--                :class="carchecked1 === item.id ? 'checked' : ''"-->
<!--                @click="checked1(item)"-->
<!--              >-->
<!--                <span>{{ item.label }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
          <!-- 品类 -->
<!--          <div class="navigation-grops">-->
<!--            <p>品类</p>-->
<!--            <ul>-->
<!--              <li-->
<!--                v-for="item in groupsClass"-->
<!--                :key="item.id"-->
<!--                :class="carchecked2 === item.id ? 'checked' : ''"-->
<!--                @click="checked2(item)"-->
<!--              >-->
<!--                <span>{{ item.label }}</span>-->
<!--              </li>-->
<!--            </ul>-->
          </div>
          <!-- 细分 -->
<!--          <div class="navigation-grops">-->
<!--            <p>细分</p>-->
<!--            <ul>-->
<!--              <li-->
<!--                v-for="item in groupsSubdivide"-->
<!--                :key="item.id"-->
<!--                :class="carchecked3 === item.id ? 'checked' : ''"-->
<!--                @click="checked3(item)"-->
<!--              >-->
<!--                <span>{{ item.label }}</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="center">
        <!-- 分页 -->
        <div style="display: flex; justify-content: right; margin-top: 10px">
          <Page
            :total="pager.total"
            :current="pager.current"
            :page-size="pager.size"
            size="small"
            :page-size-opts="[30]"
            show-total
            @on-change="changeCurrent"
            @on-page-size-change="changeSize"
          />
          <span
            style="
              line-height: 11px;
              height: 26px;
              padding: 7px 10px;
              border: 1px solid #dcdee2;
              border-radius: 3px;
            "
            >30条/页</span
          >
        </div>
        <!-- 查询区域 -->
        <div class="active">
          <div class="left">
            <ul>
              <li
                @click="synthesisChecked"
                :class="checkNum == 0 ? 'checked' : ''"
              >
                综合排序
              </li>
              <li
                @click="inventoryChecked"
                :class="checkNum == 1 ? 'checked' : ''"
              >
                <span>库存</span>
                <div class="rotate">
                  <span
                    class="iconfont icon-zuojiantou"
                    :class="searchData.stockSort == 2 ? 'checkedLi' : ''"
                  ></span
                  ><span
                    class="iconfont icon-youjiantou"
                    :class="searchData.stockSort == 1 ? 'checkedLi' : ''"
                  ></span>
                </div>
              </li>
              <li @click="priceChecked" :class="checkNum == 2 ? 'checked' : ''">
                <span>价格</span>
                <div class="rotate">
                  <span
                    class="iconfont icon-zuojiantou"
                    :class="searchData.priceSort == 2 ? 'checkedLi' : ''"
                  ></span
                  ><span
                    class="iconfont icon-youjiantou"
                    :class="searchData.priceSort == 1 ? 'checkedLi' : ''"
                  ></span>
                </div>
              </li>
              <li>
                <span>发货地：</span>
                <Select v-model="addressId" style="width: 140px" filterable>
                  <Option
                    v-for="item in cityList"
                    :value="item.id"
                    :key="item.id"
                    @click.native="chioce(item)"
                    >{{ item.name }}</Option
                  >
                </Select>
              </li>
            </ul>
          </div>
          <div class="right">
            <Checkbox v-model="hasGoods" @on-change="getDataList"
              >只显示有货</Checkbox
            >
            <!-- <Checkbox
            v-model="isActive"
            v-if="searchData.area == 1"
            @on-change="isActiveChange"
            >只显示活动</Checkbox
          > -->
          </div>
        </div>
        <!-- 表头 -->
        <Row class="tableHeader">
          <!-- <Col span="1"></Col> -->
          <Col span="2">商品图片</Col>
          <Col span="5">商品信息</Col>
          <Col span="3">店铺</Col>
          <Col span="3">发货地</Col>
          <Col span="2">库存</Col>
          <Col span="3">价格</Col>
          <Col span="3">购买数量</Col>
          <Col span="3">操作</Col>
        </Row>
        <!-- 内容 -->
        <div class="table">
          <transition-group
            name="more"
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-if="show"
          >
            <div
              class="tableCenter"
              v-for="(item, index) in dataList"
              :key="item.partId"
            >
              <Row>
                <Col span="1"></Col>
<!--                <div class="mb10">-->
<!--                  <div class="lm">{{ item.owner }}</div>-->
<!--                  <div v-show="item.source">-->
<!--                    {{ item.source }}-->
<!--                  </div>-->
<!--                  &lt;!&ndash; <div class="mb10">-->
<!--                这是一个测试我也不知道我到底要写多少个东西出来的就看着写吧!-->
<!--              </div> &ndash;&gt;-->
<!--                </div>-->
              </Row>
              <Row>
                <!-- <Col span="1">
                <div class="activeBox" v-if="item.type == 1">
                  <span class="iconfont icon-a-zu425"></span>
                  <p>优惠</p>
                </div></Col
              > -->
                <Col span="2" class="flexCenter">
                  <img
                    v-if="item.pictureUrl"
                    :src="item.pictureUrl"
                    alt="图片缺失"
                  />
                  <img
                    v-else
                    src="../../assets/images/shoppingCart/2.png"
                    alt="图片缺失"
                  />
                </Col>
                <Col span="5" class="detail" style="padding-top: 20px">
                  <div style="cursor: pointer">
                    <!-- <div class="partType">{{ item.typeName }}</div> -->
                    <div
                      class="partName"
                      @click="goDetails(item)"
                      style="max-width: 192px"
                    >
                      <span class="partType">{{ item.typeName }} </span>
                      {{ item.oeCode }}
                      <!-- </p> -->
                      <!-- <p> -->
                      {{ item.carBrandName }}

                      <!-- </p> -->
                      <!-- <p> -->
                      {{ item.direction }}{{ item.stdNameJp
                      }}{{ item.oilGrade }}
                    </div>
                  </div>

                  <div class="oe-p" @mouseleave="closeRelevance(index)">
                    OEM码：
                    <p
                      @mouseenter="getRelevance(item.partId, index, item)"
                      v-if="item.oemCodes.length"
                    >
                      {{ item.oemCodes[0]
                      }}<i
                        class="ivu-icon ivu-icon-ios-arrow-down"
                        v-if="item.oemCodes.length > 1"
                      ></i>
                    </p>
                    <div
                      class="relevance"
                      :tabIndex="1"
                      v-if="item.oemCodes.length > 1"
                    >
                      <div
                        class="relevanceBox"
                        :class="item.isShow ? 'show' : ''"
                      >
                        <!-- 关联原厂件号： -->
                        <p v-for="i in item.oemCodes.slice(1)" :key="i">
                          {{ i }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <ul style="display= flex;flex-flow: wrap;padding-left: 4px">
                    <li>
                      <!-- <span class="iconfont icon-a-lujing153"></span> -->
                      服务：
                      <!-- <p>正品保证</p> -->
                    </li>
                    <li v-if="item.genuineGuarantee">
                      <span class="iconfont icon-a-lujing153"></span>
                      <!-- <p>正品保证</p> -->
                    </li>
                    <li v-if="item.technicalSupport">
                      <!-- <li> -->
                      <span class="iconfont icon-a-ziyuan4"></span>
                      <!-- <p>技术支持</p> -->
                    </li>
                    <li v-if="item.warrantyService">
                      <!-- <li> -->
                      <span class="iconfont icon-a-ziyuan5"></span>
                      <!-- <p>保修服务</p> -->
                    </li>
                    <!-- <li> -->
                    <li v-if="item.returnPromise">
                      <!-- <li style="margin-top: 10px"> -->
                      <span class="iconfont icon-a-ziyuan21"></span>
                      <!-- <p>退换货承诺</p> -->
                    </li>
                  </ul>
                </Col>

                <Col span="3" class="flexCenter">
                  <div class="shop">
                    <p @click="goShop(item)" style="cursor: pointer">
                      {{ item.shopName }}
                    </p>
                    <span>{{ item.provinceName }}{{ item.cityName }}</span>
                  </div>
                </Col>
                <!-- 发货地 -->
                <Col span="3" class="w120">
                  <div class="oe-p" @mouseleave="closeCity(index)">
                    <p
                      class="w122"
                      @mouseenter="getCity(item.partId, index, item)"
                      v-if="item.shipCityStores.length"
                    >
                      {{ item.shipCityStore.city }}
                      {{ item.shipCityStore.name }}
                      <i
                        class="ivu-icon ivu-icon-ios-arrow-down"
                        v-if="item.shipCityStores.length > 1"
                      ></i>
                    </p>
                    <div
                      class="relevance"
                      :tabIndex="1"
                      v-if="item.shipCityStores.length > 1"
                    >
                      <div
                        class="relevanceBox w33"
                        :class="item.isShows ? 'show' : ''"
                      >
                        <p
                          v-for="i in item.shipCityStores"
                          :key="i.storeId"
                          class="w22"
                          :class="isCity === i.name ? 'isCityed' : ''"
                          @click="checkCITY(i, item)"
                        >
                          {{ i.city }}
                          {{ i.name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col span="2" class="flexCenter"
                  >{{ item.stock &lt; 10 ? item.stock : '10+' }}/{{
                    item.unitId
                  }}</Col
                >
                <Col span="3"
                  ><div class="price" style="">
                    <div v-if="!item.inquiry">
                      <!-- <div> -->
                      <p>￥{{ item.price }}</p>
                      <span
                        v-if="item.type == 1"
                        class="iconfont icon-a-lujing156"
                      ></span>
                      <span v-if="item.type == 1">{{ item.activityTime }}</span>
                    </div>
                    <p v-else>询价</p>
                  </div>
                </Col>
                <Col span="3">
                  <div class="number">
                    <div class="number-sp" :class="item.isNumber ? 'show' : ''">
                      库存不足
                    </div>
                    <div class="number-in">
                      <Button
                        style="border-right: 1px solid #dcdee2"
                        class="number-sub"
                        @click="cliSub(item, index)"
                        :disabled="item.Sub"
                        >-</Button
                      >
                      <input
                        oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
                        :id="index"
                        @blur="BlurNumber(item, index)"
                        v-model="item.maxNum"
                        style="
                          width: 53px;
                          text-align: center;
                          line-height: 31px;
                        "
                      />
                      <Button
                        class="number-add"
                        @click="cliAdd(item, index)"
                        :disabled="item.Add"
                        >+</Button
                      >
                    </div>
                    <div style="font-size: 1px; margin-top: 5%" v-show="item.latestTime ? !null : false">于{{ item.latestTime }}，购买{{ item.partNum }}{{ item.unitId }}</div>
                    
                  </div>
                </Col>
                <Col span="3">
                  <div
                    class="handle"
                    v-if="tenantId !== item.tenantId"
                    style="padding-top: 10px"
                  >
                    <div class="left">
                      <!-- <span
                  v-if="item.isCollect == true"
                  class="iconfont icon-shoucang"
                  title="收藏"
                  @click="getCollect(item, index, false)"
                ></span>

                <span
                  v-else
                  class="iconfont icon-a-lujing157"
                  title="收藏"
                  @click="getCollect(item, index, true)"
                ></span> -->
                      <span
                        style="padding-top: 4px"
                        class="iconfont"
                        :class="
                          item.attention ? 'icon-a-ziyuan1' : 'icon-a-lujing157'
                        "
                        @click="collect(item)"
                      ></span>
                      <div v-if="!item.inquiry" class="regular">
                        <span
                          class="iconfont icon-a-zu420"
                          title="加入购物车"
                          @click="setShopCat(item, index)"
                        ></span>
                      </div>
                      <div v-else class="noregular">
                        <span class="iconfont icon-a-zu420"></span>
                      </div>
                      <!-- <span
                  v-else
                  class="iconfont icon-a-lujing205"
                  title="加入询价单"
                ></span> -->
                      <!-- <span
                    @click="go('im')"
                    c
                    title="联系客服"
                  ></span> -->
                      <xiaopei
                        style="padding-top: 4px"
                        :oppositeTenantId="item.tenantId"
                        :partId="item.partId"
                        ><i class="iconfont icon-a-lujing162"></i
                      ></xiaopei>
                      <!-- icon-a-ziyuan1  icon-a-lujing157 -->
                    </div>
                    <div
                      class="right"
                      v-if="item.inquiry == 0"
                      style="marhin-right: 0"
                    >
                      <Button
                        @click="prebuy(item)"
                        type="error"
                        :loading="item.buyLoading"
                        >立即购买</Button
                      >
                    </div>
                    <div class="right" v-if="item.inquiry == 1">
                      <Button @click="enquiry(item)" type="primary"
                        >立即询价</Button
                      >
                    </div>
                  </div></Col
                >
              </Row>
            </div>
          </transition-group>
          <!-- 数据为空 -->
          <div class="emptyData" v-if="dataList.length == 0">
            <p>
              <span
                ><i
                  ><Icon
                    type="ios-alert-outline"
                    size="17"
                  />没找到您想要的数据~</i
                ></span
              >
            </p>
          </div>
          <!-- 加载中 -->
          <div class="demo-spin-container" v-if="spinShow">
            <Spin fix></Spin>
          </div>
        </div>
        <div style="display: flex; justify-content: right; margin-top: 10px">
          <Page
            :total="pager.total"
            :current="pager.current"
            :page-size="pager.size"
            size="small"
            :page-size-opts="[30]"
            show-total
            @on-change="changeCurrent"
            @on-page-size-change="changeSize"
          />
          <span
            style="
              line-height: 11px;
              height: 26px;
              padding: 7px 10px;
              border: 1px solid #dcdee2;
              border-radius: 3px;
            "
            >30条/页</span
          >
        </div>
      </div>
    </div>
    <enquirytk
      ref="enquirytkl"
      :enquirydata="enquirydata"
      @enquirysx="enquirysx"
    ></enquirytk>
    <Footer></Footer>
    <FooterP></FooterP>
  </div>
</template>

<script>
import {
  // getDataList,
  getListAddress,
  getattention,
  // getenquiryqd,
  // getListPartsType,
  getDataListworld
} from '@/api/goodsList.js'
import { getlistAllGroup } from '../../api/partnavigation.js'
import Slider from '../base/common/slider.vue'
import HeaderTop from '../base/common/header-top.vue'
import HeaderSearch from '../base/common/header-search.vue'
import Footer from '../base/common/footer.vue'
import FooterP from '@/views/base/common/footer-p.vue'
import { listData } from '@/views/base/common/listData.js'
import xiaopei from '@/views/xiaopei/index.vue'
import enquirytk from '../base/common/enquirytk.vue'
export default {
  mixins: [listData],
  components: {
    HeaderTop,
    Slider,
    HeaderSearch,
    Footer,
    FooterP,
    xiaopei,
    enquirytk
  },
  data() {
    return {
      keyword: this.$route.query.VINSearch,
      searchWord: '',
      groups: [], // 分组
      groupsClass: [], // 品类
      groupsSubdivide: [], // 细分
      parTypeList: [], // 配件类型
      brandList: [], // 品牌
      carchecked5: '', // 选中品牌
      carchecked4: '',
      carchecked3: '',
      carchecked2: '',
      carchecked1: '',
      searchData: {
        keyword: '',
        vinCode: this.$route.query.VINSearch,
        partType1: '',
        partType2: '',
        standardGroup: '', // 分组id
        area: 6,
        brandId: '',
        current: 1,
        inStock: '',
        // leagueId: '',
        partType: '',
        priceSort: '', // 价格查询排序,(1升序，2降序)
        // shopId: '',
        shipCityId: '',
        size: 30,
        stockSort: '' // 库存查询排序
      },
      checkNum: 0, // 0/销量 1/库存 2/价格
      inventoryNum: 0, //库存点击次数
      priceNum: 0, //价格点击次数
      transactionAmount: 0, //交易数量
      brandArr: [], // 品牌数组（回填头部）
      enquiryAmount: 0, //询价数量
      addressId: '', // 收货地址
      cityList: [],
      hasGoods: false,
      enquirydata: {}, // 询价数据
      carResult: {} // 车型/vin查询结果
    }
  },
  created() {
    // this.getListPartsType()
    this.getlistAllGroup()
    this.getListAddress()
  },
  methods: {
    // 获取配件类型
    // async getListPartsType() {
    //   const res = await getListPartsType()
    //   console.log(res)
    //   if (res.code == 0) {
    //     this.parTypeList = res.data
    //     this.parTypeList.unshift({ value: '-1', name: '不限' })
    //     this.carchecked4 = this.parTypeList[0].value
    //   }
    // },
    // 获取配件分类导航分组
    async getlistAllGroup() {
      let res = await getlistAllGroup()
      console.log(res, '配件分类所有数据')
      this.groupsList = JSON.parse(JSON.stringify(res.data.world))
      this.groups = res.data.world[0]
      this.groups.unshift({ id: '-1', label: '不限' })
      this.groupsClass.unshift({ id: '-1', label: '不限' })
      this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
      this.searchData.standardGroup = '-1'
      this.carchecked1 = this.groups[0].id
      this.carchecked2 = this.groupsClass[0].id
      this.carchecked3 = this.groupsSubdivide[0].id
    },
    // 获取收货地址
    async getListAddress() {
      let res = await getListAddress()
      console.log(res, '查询的商品列表')
      this.cityList = res.data
      this.cityList.unshift({ id: '-1', name: '全国' })
      this.addressId = '-1'
      this.searchData.shipCityId = this.addressId
      this.getDataList()
    },
    // 改变发货地
    chioce(item) {
      this.searchData.shipCityId = item.id
      this.changeListsBtn()
    },
    // 获取了数据
    async getDataList(i) {
      console.log(this.searchData.vinCode)
      console.log(this.keyword)
      console.log(this.$route.query.VINSearch)
      if (i == 2) {
        this.searchData.subarea = 61
      } else if (i == 3) {
        this.searchData.keyword = ''
        this.addressId = '-1'
        this.searchData.shipCityId = this.addressId
        this.searchData.size = 30
        this.searchData.current = 1
        this.searchData.sellerTenantId = "1483458026179055616"
      }
      this.show = true
      this.spinShow = true
      this.searchData.vinCode = this.$route.query.VINSearch
      this.keyword = this.$route.query.VINSearch
      this.searchData.sellerTenantId = "1483458026179055616"
      this.searchData.shipCityId =
        this.searchData.shipCityId == '-1' ? '' : this.searchData.shipCityId
      this.searchData.inStock = this.hasGoods ? 1 : ''
      this.searchData.standardGroup =
        this.searchData.standardGroup == '-1'
          ? ''
          : this.searchData.standardGroup
      this.searchData.partType1 =
        this.searchData.partType1 == '-1' ? '' : this.searchData.partType1
      this.searchData.partType2 =
        this.searchData.partType2 == '-1' ? '' : this.searchData.partType2
      console.log(this.searchData)
      let res = await getDataListworld(this.searchData)
      console.log(res)
      if (res.status) {
        if (i == 1) {
          this.$nextTick(() => {
            this.brandList = res.data.partBrandVOList
            this.parTypeList = res.data.partsTypeList
            this.parTypeList.unshift({ id: '-1', name: '不限' })
            // this.carchecked4 = this.parTypeList[0].id
            // if (this.carchecked5) {
            this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            // } else {
            //   this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            //   this.carchecked5 = this.brandList[0].carBrandId
            // }
            // this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            // this.carchecked5 = this.brandList[0].carBrandId
            // this.$refs.searchTop.getListBrandType(this.brandArr)
            this.dataList = res.data.ipage.records
            this.pager.total = res.data.ipage.total
            this.transactionAmount = res.data.ipage.total
            if (res.data.modelVO !== null) {
              this.carResult = res.data.modelVO
            }
            this.enquiryAmount = res.data.enquiryAmount
            console.log(this.carchecked5)
            this.getMaxNum()
          })
        } else {
          this.$nextTick(() => {
            this.brandList = res.data.partBrandVOList
            this.parTypeList = res.data.partsTypeList
            this.parTypeList.unshift({ id: '-1', name: '不限' })
            this.carchecked4 = this.parTypeList[0].id
            if (this.carchecked5) {
              this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            } else {
              this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
              this.carchecked5 = this.brandList[0].carBrandId
            }
            // this.brandList.unshift({ carBrandId: '-1', carBrandName: '不限' })
            // this.carchecked5 = this.brandList[0].carBrandId
            // this.$refs.searchTop.getListBrandType(this.brandArr)
            this.dataList = res.data.ipage.records
            this.pager.total = res.data.ipage.total
            this.transactionAmount = res.data.ipage.total
            if (res.data.modelVO !== null) {
              this.carResult = res.data.modelVO
            }
            this.enquiryAmount = res.data.enquiryAmount
            console.log(this.carchecked5)
            this.getMaxNum()
          })
        }
      } else {
        this.dataList = []
        this.brandList = []
        // this.$refs.searchTop.getListBrandType([])
      }
      this.spinShow = false
    },
    // 分组
    checked1(val) {
      this.groupsClass = []
      this.carchecked1 = val.id
      this.carchecked2 = '-1'
      this.searchData.partType2 = '-1'
      this.searchData.standardGroup = '-1'
      this.carchecked3 = '-1'
      // this.groupsClass = JSON.parse(JSON.stringify(this.groupsList[val.id]))
      const arr = JSON.parse(JSON.stringify(this.groupsList[val.id] || []))
      const obj = {
        id: '-1',
        label: '不限'
      }
      if (JSON.stringify(arr).indexOf(JSON.stringify(obj)) == -1) {
        console.log('不存在')
        arr.unshift(obj)
        console.log(arr)
      }
      this.groupsClass = arr
      // this.groupsClass = this.groupsList[val.id]
      // console.log(this.groupsClass)
      this.groupsSubdivide = []
      this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
      this.searchData.partType1 = val.id
      this.getDataList(1)
    },
    // 品类
    checked2(val) {
      this.carchecked3 = '-1'
      this.searchData.standardGroup = '-1'
      this.groupsSubdivide = []
      this.carchecked2 = val.id
      // const checkedList = JSON.parse(JSON.stringify(this.groupsList[val.id]))
      // checkedList.unshift({ id: '', label: '不限' })
      const arr = JSON.parse(JSON.stringify(this.groupsList[val.id] || []))
      const obj = {
        id: '-1',
        label: '不限'
      }
      if (JSON.stringify(arr).indexOf(JSON.stringify(obj)) == -1) {
        arr.unshift(obj)
      }
      this.groupsSubdivide = arr
      // this.groupsSubdivide = this.groupsList[val.id]
      // this.groupsSubdivide = checkedList
      // this.groupsSubdivide.unshift({ id: '-1', label: '不限' })
      // if (val.id == '-1') {
      //   this.searchData.standardGroup = this.carchecked1
      // } else {
      this.searchData.partType2 = val.id
      // }
      // this.searchData.standardGroup = val.id
      this.getDataList(1)
      // this.carchecked2 = '-1'
      // this.carchecked3 = '-1'
    },
    // 细分
    checked3(val) {
      console.log(val)
      console.log(this.carchecked2)
      this.carchecked3 = val.id
      // if (val.id == '-1') {
      //   this.searchData.standardGroup = this.carchecked2
      // } else {
      this.searchData.standardGroup = val.id
      // }

      this.getDataList(1)
    },
    // 配件类型
    checked4(val) {
      console.log(val)
      this.carchecked4 = val.id
      let i = JSON.parse(JSON.stringify(val.id === '-1' ? '' : val.id))
      this.searchData.partType = i
      this.searchData.brandId = ''
      this.searchData.current = 1
      this.searchData.size = 30
      ;(this.pager = {
        current: 1,
        size: 30,
        total: 0
      }),
        this.getDataList(1)
    },
    // 品牌
    checked5(val) {
      console.log(val)
      this.carchecked5 = val.carBrandId
      console.log(this.carchecked5)
      let i = JSON.parse(
        JSON.stringify(val.carBrandId === '-1' ? '' : val.carBrandId)
      )
      this.searchData.brandId = i
      this.searchData.current = 1
      this.searchData.size = 30
      ;(this.pager = {
        current: 1,
        size: 30,
        total: 0
      }),
        this.getDataList(1)
      console.log(this.carchecked5)
      // this.carchecked5 = val.carBrandId
    },
    // 立即询价
    enquiry(item) {
      console.log(item)
      // this.enquirytk = true
      this.enquirydata = JSON.parse(JSON.stringify(item))
      this.$refs.enquirytkl.enquirytkc()
      // this.enquirydata = item
      console.log(this.enquirydata)
    },
    // 询价刷新
    enquirysx() {
      this.$refs.shopcar.getenquirydata()
    },
    // 关注
    async collect(item) {
      item.attention = !item.attention
      console.log('收藏')
      if (item.attention) {
        item.attention = 1
      } else {
        item.attention = 0
      }
      console.log(item.attention)
      const res = await getattention({
        partId: item.partId,
        attention: item.attention
      })
      console.log(res)
      if (res.status) {
        if (item.attention == 1) {
          this.$Message.success('关注成功')
        } else {
          this.$Message.error('关注取消')
        }
        return
      } else {
        item.attention = !item.attention
      }
    },
    // 切换专区
    headerClick(num) {
      console.log(num)
      this.searchData.area = num
      if (num == 1) {
        this.hasGoods = false
      } else {
        this.hasGoods = true
      }
      this.checkNum = 0
      this.inventoryNum = 0
      this.searchData.stockSort = ''
      this.priceNum = 0
      this.searchData.priceSort = ''
      this.changeListsBtn()
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
@import '../supportself/index.less';
@import './index.less';
</style>